<template>
  <v-container fluid class="pa-0">
    <v-layout row fluid>
      <v-flex>
        <v-card flat>
          <v-card-text class="headline">
            Download Center
          </v-card-text>

          <v-card-text style="padding: 0px; margin: 0px;">
            <FixedTableIE :widthSub="widthSub" :heightSub="100" :heightCRSSub="0" ref="sdTable"
                          @onActionButtonClick="onActionButtonClick"
                          :hasAmpel=true
                          :currency="currentCurrency"
                          :selected="selected"
                          :tableConfig='tableConfig'
                          :headers="headers" :items="rows" class="colorrows">
            </FixedTableIE>
  
            <div v-if="((rows === null))" class="font-weight-bold bluetext textleft missingDataInPeergroup">
              {{'DLC_NO_ITEMS' | translate}}
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <HitlistCounter></HitlistCounter>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import FixedTableIE from './../tables/EasyTableIE'
  import HitlistCounter from '../widgets/HitlistCounter'

  export default {
    name: 'DownloadCenter.vue',
    components: { HitlistCounter, FixedTableIE },
    data() {
      return {
        widthSub: 0,
        timer: null,
        headers: [{
          "text": "Aktion",
          "meta": {
            "type": "action",
            "title": "Aktion",
            "width": "10",
            "align": "L",
            "format": "text"
          },
          "value": "-1",
          "format": 'action',
          "isExtraField": false,
          "columnClass": "col00",
          "index": -1,
          "id": -1,
          "isVisible": true,
          "sortable": true
        }],
        rows: [],
        selected: false,
        currentCurrency: '1',
        'tableConfig': {
          selection: false,
          isClickable: true,
          actionButtons: {
            buttons: [
            {
                index: 0,
                icon: 'file_download',
                type: 'event',
                action: 'download',
                checkProperty: 'canDownload',
                tooltipText: Vue.i18n.translate('TOOLTIP_DELETE')
              },
              {
                index: 1,
                icon: 'clear',
                color: '#E05469',
                type: 'event',
                action: 'delete',
                tooltipText: Vue.i18n.translate('TOOLTIP_DELETE')
              }
            ]
          },
          header: {
            columnClass: 'verlauf abstandunten04 theme--light blue tableIEPadding1 headcolumn'
          },
          rows: {
            rowClass: 'rowEIE'
          }
        }
       }
    },
    methods: {
      onActionButtonClick: function (data) {
        var cmp = this;
        var item = data.item;
        var jobId = item.meta.jobId;
        if (data.button.action === 'delete') {
          Vue.prototype.$api.sendGetRequest('apiDownloadCenter.php', {delete:'', id: jobId}, null, function (data) {
            if (data.success == true) {
              cmp.$refs.sdTable.deleteRow(item);
            }
          });
          return;
        }
        if (data.button.action === 'download') {
          var url = Vue.prototype.storage.host() + '/apiDownloadCenter.php?download&id=' + jobId;
          window.open (url);
          return;
        }
        alert("foo" +  JSON.stringify(data, null, 4) + "bar " + JSON.stringify(data.item.meta));
      },
      collapseEvent: function (isMini) {
        if (isMini) {
          this.widthSub = 40
  
        } else {
          this.widthSub = 350
        }
      },
      openTable: function () {
        var cmp = this
        if (this.$refs.sdTable && this.$refs.sdTable.updateData) {
          this.$refs.sdTable.updateHeader(this.headers)
          let orderCellName = null
          if (cmp.first) {
            for (var i = 0;i < this.headers.length; i++) {
              let headItem = this.headers[i]
              if (headItem.meta.id.indexOf('Name') > -1) {
                orderCellName = i + 1
                cmp.first = false
                break;
              }
            }
          }
          this.$refs.sdTable.updateData(cmp.rows, true, orderCellName)
        }
        if (this.timer == null) {
          this.timer = setInterval(function (param) {
            var cmp = param;
              console.log("refresh triggered");
              Vue.prototype.$api.getDownloads(null, function (data) {
                var result = Vue.prototype.$api.prepareWaimeaTable(data.table)
                cmp.rows = result.rows
                if (cmp.rows) {
                  Vue.prototype.$eventHub.$emit('hitlistcounter', {
                    hits: data.table.rows.length,
                    totalHits: data.totalHits,
                    totalHitsAppendix: data.totalHitsAppendix
                  });
                }
                cmp.$refs.sdTable.updateData(cmp.rows, true, null)
              });
            }, 10000, cmp);
        }
      },
      open: function (data) {
        this.headers = []
        var result = Vue.prototype.$api.prepareWaimeaTable(data.table)
        this.rows = result.rows
        this.headers = result.headers;
        if (data && data.table && data.table.rows && data.table.rows) {
          Vue.prototype.$eventHub.$emit('hitlistcounter', {
            hits: data.table.rows.length,
            totalHits: data.totalHits,
            totalHitsAppendix: data.totalHitsAppendix
          })
        } else {
          Vue.prototype.$eventHub.$emit('hitlistcounter', {
            hits: -1,
            totalHits: -1,
            totalHitsAppendix: ''
          })
        }
        /*
        var cmp = this
        if (this.$refs.sdTable && this.$refs.sdTable.updateData) {
          this.$nextTick(function () {
            cmp.$refs.sdTable.updateData(cmp.pgresults)
          })
        }
         */
        this.openTable()
      },
      close: function () {
        if (this.$refs.sdTable && this.$refs.sdTable.doDestroyTable) {
          this.$refs.sdTable.doDestroyTable()
        }
      },
    },
    created() {
    },
    destroyed() {
    },
    mounted() {
      var cmp = this;
      Vue.prototype.$eventHub.$emit('OnGetModuleTitle', 'DownloadCenter');
      Vue.prototype.$eventHub.$emit('hitlistcounter', {
        hits: -1,
        totalHits: -1,
        totalHitsAppendix: ''
      })
      Vue.prototype.$api.getDownloads(null, function (data) {
        cmp.open(data);
      })
    },
    beforeDestroy() {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/module/DownloadCenter.vue